// extracted by mini-css-extract-plugin
export default {"ellipseButton":"ellipse-button_ellipseButton__pHQBM"};